import * as ActionTypes from '../../../constants';
import { generateProjectName } from '../../../utils/generateRandomName';

const initialState = () => {
  const generatedString = generateProjectName();
  const generatedName =
    generatedString.charAt(0).toUpperCase() + generatedString.slice(1);
  return {
    name: generatedName,
    updatedAt: '',
    isSaving: false,
    visibility: 'Public'
  };
};

const project = (state, action) => {
  if (state === undefined) {
    state = initialState(); // eslint-disable-line
  }
  switch (action.type) {
    case ActionTypes.SET_PROJECT_NAME:
      return Object.assign({}, { ...state }, { name: action.name });
    case ActionTypes.SET_PROJECT_VISIBILITY:
      return Object.assign(
        {},
        { ...state },
        { visibility: action.visibility, updatedAt: action.updatedAt }
      );
    case ActionTypes.NEW_PROJECT:
      return {
        id: action.project.id,
        name: action.project.name,
        updatedAt: action.project.updatedAt,
        owner: action.owner,
        isSaving: false,
        visibility: action.project.visibility,
        editableByLink: action.project.editableByLink ?? false,
        // Per-project AR session token. Carried through so the same QR/session is reused
        // instead of regenerated (and invalidated) on each AR-button press.
        arSessionId: action.project.arSessionId ?? null
      };
    case ActionTypes.SET_PROJECT:
      return {
        id: action.project.id,
        name: action.project.name,
        updatedAt: action.project.updatedAt,
        owner: action.owner,
        isSaving: false,
        visibility: action.project.visibility,
        editableByLink: action.project.editableByLink ?? false,
        arSessionId: action.project.arSessionId ?? null
      };
    // Set after ensureArSessionId lazily creates the token, so a same-session second press
    // reuses it (SET_PROJECT/getProject only run on load, not between presses).
    case ActionTypes.SET_PROJECT_AR_SESSION_ID:
      return Object.assign({}, state, { arSessionId: action.value });
    // Whether the open sketch is a published AR example (resolved async on load from the `examples`
    // collection). SET_PROJECT/NEW_PROJECT rebuild state fresh, so this clears on each load until the
    // check resolves. Gates admin-only editing via selectCanEditSketch.
    case ActionTypes.SET_PROJECT_IS_EXAMPLE:
      return Object.assign({}, state, { isExample: action.value });
    // Set when a sketch fails to load (private/non-owned or non-existent). Drives the
    // "private or doesn't exist" view instead of silently showing a blank default editor.
    case ActionTypes.SET_PROJECT_NOT_FOUND:
      return Object.assign({}, state, { notFound: action.value });
    case ActionTypes.RESET_PROJECT:
      return initialState();
    case ActionTypes.SET_PROJECT_SAVED_TIME:
      return Object.assign({}, state, { updatedAt: action.value });
    case ActionTypes.START_SAVING_PROJECT:
      return Object.assign({}, state, { isSaving: true });
    case ActionTypes.END_SAVING_PROJECT:
      return Object.assign({}, state, { isSaving: false });
    default:
      return state;
  }
};

export default project;
